import React, { useState } from 'react';
import { Download, FileCheck } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Checkbox } from '../ui/Checkbox';
import { Badge } from '../ui/Badge';
interface Step7Props {
  trainees: Array<{
    id: string;
    name: string;
    email: string;
  }>;
  attendance: Record<string, any[]>;
  schedules: any[];
  certificates: any[];
  onChange: (certificates: any[]) => void;
}
export function Step7Certificates({
  trainees,
  attendance,
  schedules,
  certificates,
  onChange
}: Step7Props) {
  const [selectedTrainees, setSelectedTrainees] = useState<string[]>([]);
  const getAttendanceSummary = (traineeId: string) => {
    let presentCount = 0;
    Object.values(attendance).forEach(sessionAttendance => {
      const record = sessionAttendance.find(a => a.traineeId === traineeId);
      if (record?.status === 'present') presentCount++;
    });
    return `${presentCount}/${schedules.length}`;
  };
  const getCertificateStatus = (traineeId: string) => {
    const cert = certificates.find(c => c.traineeId === traineeId);
    return cert?.status || 'not_issued';
  };
  const toggleTrainee = (traineeId: string) => {
    if (selectedTrainees.includes(traineeId)) {
      setSelectedTrainees(selectedTrainees.filter(id => id !== traineeId));
    } else {
      setSelectedTrainees([...selectedTrainees, traineeId]);
    }
  };
  const generateCertificates = () => {
    const newCertificates = [...certificates];
    selectedTrainees.forEach(traineeId => {
      const existing = newCertificates.find(c => c.traineeId === traineeId);
      if (!existing) {
        newCertificates.push({
          traineeId,
          status: 'issued',
          issuedDate: new Date().toISOString()
        });
      } else if (existing.status === 'not_issued') {
        existing.status = 'issued';
        existing.issuedDate = new Date().toISOString();
      }
    });
    onChange(newCertificates);
    setSelectedTrainees([]);
  };
  return <Card title="Certificate Management" data-id="element-196">
      <div className="space-y-6" data-id="element-197">
        {selectedTrainees.length > 0 && <div className="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-198">
            <p className="text-sm text-blue-900" data-id="element-199">
              <strong data-id="element-200">{selectedTrainees.length}</strong> trainee(s) selected for
              certificate generation
            </p>
            <Button onClick={generateCertificates} data-id="element-201">
              <FileCheck className="w-4 h-4 mr-2" data-id="element-202" />
              Generate Certificates
            </Button>
          </div>}

        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-203">
          <table className="w-full" data-id="element-204">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-205">
              <tr data-id="element-206">
                <th className="px-4 py-3 text-left" data-id="element-207">
                  <Checkbox data-id="element-208" />
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-209">
                  SL
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-210">
                  Name
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-211">
                  Email
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-212">
                  Attendance
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-213">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-214">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-215">
              {trainees.map((trainee, index) => {
              const status = getCertificateStatus(trainee.id);
              const isIssued = status === 'issued';
              return <tr key={trainee.id} className="hover:bg-gray-50" data-id="element-216">
                    <td className="px-4 py-3" data-id="element-217">
                      <Checkbox checked={selectedTrainees.includes(trainee.id)} onChange={() => toggleTrainee(trainee.id)} disabled={isIssued} data-id="element-218" />
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-219">
                      {index + 1}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-220">
                      {trainee.name}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-221">
                      {trainee.email}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900" data-id="element-222">
                      {getAttendanceSummary(trainee.id)} sessions
                    </td>
                    <td className="px-4 py-3" data-id="element-223">
                      <Badge variant={isIssued ? 'success' : 'default'} data-id="element-224">
                        {isIssued ? 'Issued' : 'Not Issued'}
                      </Badge>
                    </td>
                    <td className="px-4 py-3" data-id="element-225">
                      {isIssued && <button className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm" title="Download Certificate" data-id="element-226">
                          <Download className="w-4 h-4" data-id="element-227" />
                          Download
                        </button>}
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </div>
    </Card>;
}